import React from "react";
import { Link } from "react-router-dom";
import { money, sized, srcSet } from "../lib/api";
import { BlurImage } from "./BlurImage";

const LOW_STOCK = 3;

export const ProductCard = ({ p, index = 0, to }) => {
  const link = to || `/etchings/${p.slug}`;
  const sold = p.availability === "sold";
  const reserved = p.availability === "reserved";
  const inv = Number(p.inventory ?? 0);
  const lowStock = !sold && !reserved && p.kind === "etching" && inv > 0 && inv <= LOW_STOCK;
  const priority = index === 0; // LCP candidate — load eagerly instead of lazily
  return (
    <div data-testid={`product-card-${p.slug}`} className="animate-[fadeIn_0.6s_ease-out_both]" style={{ animationDelay: `${(index % 3) * 80}ms` }}>
      <Link to={link} className="group block">
        <div className="relative overflow-hidden bg-[#F0EFEA] border border-[#E4E1DB]">
          <BlurImage
            src={sized(p.primary_image, 800)}
            srcSet={srcSet(p.primary_image)}
            sizes="(min-width:768px) 33vw, 100vw"
            alt={p.image_alt || p.display_title || p.title}
            width="800" height="1000"
            eager={priority}
            fetchPriority={priority ? "high" : undefined}
            className="w-full h-[380px] object-cover transition-transform duration-1000 ease-out group-hover:scale-105"
          />
          {lowStock && (
            <span data-testid={`product-lowstock-${p.slug}`}
              className="absolute top-3 left-3 bg-[#F9F8F6]/90 backdrop-blur-sm text-[#B35D4B] text-[0.62rem] tracking-[0.12em] uppercase px-2.5 py-1 border border-[#E4E1DB]">
              {inv === 1 ? "Last one" : `Only ${inv} left`}
            </span>
          )}
        </div>
        <div className="pt-4 flex items-start justify-between gap-4">
          <div>
            <h3 className="font-display text-xl leading-tight">{p.display_title || p.title}</h3>
            {p.short_descriptor && <p className="text-sm text-[#4A4947] mt-1">{p.short_descriptor}</p>}
          </div>
          {p.for_sale !== false && (
            <div className="text-right shrink-0">
              <span className="text-sm">{money(p.price, p.currency)}</span>
              {sold && <div className="overline text-[#B35D4B] mt-1">Sold</div>}
              {reserved && <div className="overline text-[#5B6C7A] mt-1">Reserved</div>}
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};
